import { zeichen } from "./zeichen.js";

/**
 * Die Marke „Telegram“ mit Papierflieger in der Zeitzeile einer Blase. (30.09.2026, Ticket 2864;
 * seit Ticket 2892 mit gezeichnetem Papierflieger statt „· “)
 *
 * Martin spricht mit EINER Vespera in mehreren Kanälen (App, Sprechtaste,
 * Anruf, Telegram). Wer im Verlauf liest, soll sehen, wo etwas stand — leise,
 * wie der Modell-Vermerk daneben (.bubble-modell). Nur Telegram trägt einen
 * Vermerk: die App ist der Normalfall.
 *
 * Der Kanal kommt an drei Stellen an und geht an allen drei hierher: live über
 * den Bus (`source`), nach dem Nachladen aus der Datenbank (`metadata.source`,
 * seit Ticket 2864 geschrieben) und beim Wiederaufbau aus dem lokalen Verlauf
 * (`kanal` im Eintrag).
 */

/** Die Kanäle mit Vermerk: Telegram und (31.10.2026) das V9-Gespräch (`source=neun`, server/neun/chat-zeilen.ts). */
export type VermerkKanal = "telegram" | "neun";

/** Der Kanal, der einen Vermerk trägt — oder `undefined` (App, unbekannt, alte Zeile). */
export function kanalAusQuelle(quelle: unknown): VermerkKanal | undefined {
  return quelle === "telegram" || quelle === "neun" ? quelle : undefined;
}

/**
 * Hängt den Vermerk an die Zeitzeile (`.bubble-ts`) der Blase. Ohne Zeitzeile
 * oder ohne Vermerk-Kanal geschieht nichts; doppelt aufgerufen, steht er einmal.
 */
export function setzeKanalVermerk(blase: HTMLElement, kanal: string | null | undefined): void {
  if (kanal !== "telegram" && kanal !== "neun") return;
  const zeit = blase.querySelector<HTMLElement>(":scope > .bubble-ts");
  if (!zeit || zeit.querySelector(".bubble-kanal")) return;
  const marke = document.createElement("span");
  marke.className = "bubble-kanal";
  // V9: nur das Wort, ohne Zeichen.
  if (kanal === "neun") {
    marke.append(" ", "V9");
    marke.title = "Im V9-Gespräch gesagt";
    zeit.appendChild(marke);
    return;
  }
  // Der Flieger ist gezeichnet (Zeichen-Vorrat), kein Emoji und nicht für Vorleser gedacht: das Wort daneben sagt es.
  const flieger = document.createElement("span");
  flieger.className = "bubble-kanal-zeichen";
  flieger.innerHTML = zeichen("telegram", 12);
  const wort = document.createElement("span");
  wort.textContent = "Telegram";
  marke.append(" ", flieger, wort);
  marke.title = "Über Telegram geschrieben";
  zeit.appendChild(marke);
}
